import { createTheme, responsiveFontSizes } from '@mui/material';

let theme = createTheme({
	shape: {
		borderRadius: 10,
	},
	typography: {
		fontFamily: 'Rubik, sans-serif',
		body2: {
			fontWeight: 500,
		},
	},
	palette: {
		primary: {
			main: '#3FAE6D',
		},
		background: {
			default: '#F8F8F8',
			paper: '#FFFFFF',
		},
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			xl: 1500,
			lg: 1090,
		},
	},
	components: {
		MuiFormHelperText: {
			styleOverrides: {
				root: ({ theme }) => ({
					[theme.breakpoints.up('sm')]: {
						position: 'absolute',
						top: '100%',
					},
				}),
			},
		},
		MuiFilledInput: {
			styleOverrides: {
				root: ({ theme }) => ({
					background: theme.palette.background.default,
				}),
			},
		},
	},
});

theme = responsiveFontSizes(theme);

export default theme;
